module.exports = __webpack_public_path__ + "static/media/exc_env_ris_ass.972d1907.png";